import type { Price } from '@montugroup/circuit-shared';
import type { CreditLineItem } from '@montugroup/circuit-shared/types/refill';
import BigNumber from 'bignumber.js';

export function formatPrice(price: Price) {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  }).format(Number(price));
}

export type CheckoutProduct = {
  id: number;
  data: {
    product_id: number;
    product_name: string;
    price: Price;
    quantity: number;
    brand: string;
    is_concession: boolean;
    discount?: {
      id: string;
      display: string;
      amount: number | string;
      formattedAmount: string;
    };
  };
};

export function getCheckoutData(selectedProducts: CheckoutProduct[], creditsDiscounts: CreditLineItem[]) {
  const discounts = creditsDiscounts
    .filter((creditOrDiscount) => creditOrDiscount.isDiscount)
    .map((discount) => {
      const discountAmount = Math.abs(discount.amount || 0);
      let formattedDiscountAmount = '';

      formattedDiscountAmount = discountAmount <= 0 ? 'Free' : `${formatPrice(discountAmount)}`;

      return {
        id: discount.id,
        amount: discountAmount,
        display: discount.displayName, //this change is only temporary until UMED-1226 is ready
        formattedAmount: formattedDiscountAmount,
        productId: discount.productId,
      };
    });

  const products = selectedProducts
    .filter((p) => p.data.quantity >= 1)
    .map((selectedProduct) => {
      const productDiscount = discounts.find((discount) => discount.productId === selectedProduct.data.product_id);
      const totalPrice = BigNumber(selectedProduct.data.price).multipliedBy(selectedProduct.data.quantity).toNumber();

      return {
        id: selectedProduct.data.product_id,
        name: selectedProduct.data.product_name,
        price: selectedProduct.data.price,
        quantity: selectedProduct.data.quantity,
        supplier: selectedProduct.data.brand,
        totalPrice,
        formattedTotalPrice: formatPrice(totalPrice),
        isConcession: selectedProduct.data.is_concession,
        discount: productDiscount,
      };
    });

  const totalNumberOfProducts = products.reduce((total, { quantity }) => total + quantity, 0);

  // NOTE: using BigNumber for adding posible decimal numbers
  const discountedTotalPrice = products
    .reduce(
      (total: BigNumber, product) => total.plus(BigNumber(product.discount?.amount || product.totalPrice)),
      BigNumber(0),
    )
    .toNumber();
  const formattedDiscountedTotalPrice = formatPrice(discountedTotalPrice);

  return {
    products,
    totalNumberOfProducts,
    totalPrice: discountedTotalPrice,
    discounts,
    formattedTotalPrice: formattedDiscountedTotalPrice,
  };
}

export default getCheckoutData;
